'use es6';

export const PAGES_API_BASE_URL = 'cospages/v2';
export const BLOG_LISTING_PAGES_API_BASE_URL = 'blogs/v3';
export const CONSUMER_NAME = 'page-editor-ui';
export const AUTOSAVE_THEME_SAVE_PERIOD = 500;